import { createSvgIcon } from '@mui/material';
import React from 'react';

export const WorkspacesOutlinedCustom = createSvgIcon(
    <>
        <path
            d="M6 15C7.1 15 8 15.9 8 17C8 18.1 7.1 19 6 19C4.9 19 4 18.1 4 17C4 15.9 4.9 15 6 15ZM6 13C3.8 13 2 14.8 2 17C2 19.2 3.8 21 6 21C8.2 21 10 19.2 10 17C10 14.8 8.2 13 6 13ZM12 5C13.1 5 14 5.9 14 7C14 8.1 13.1 9 12 9C10.9 9 10 8.1 10 7C10 5.9 10.9 5 12 5ZM12 3C9.8 3 8 4.8 8 7C8 9.2 9.8 11 12 11C14.2 11 16 9.2 16 7C16 4.8 14.2 3 12 3Z"
            fill="currentColor"
        />
        <path
            d="M23.9991 18.255H19.3363V22.9463H17.782V18.255H13.1191V16.6913H17.782V12H19.3363V16.6913H23.9991V18.255Z"
            fill="currentColor"
        />
    </>,
    'WorkspacesOutlinedCustom'
);
